module.exports = __webpack_public_path__ + "img/dcc9a52.jpg";